import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import RedirectToNewNpsPage from '../pages/RedirectToNewNpsPage'

const RootPage = React.lazy(() => import('modules/posts/pages/RootPage'))

const npsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.dashboard.nps.path,
      element: <RootPage kind="nps" />,
      children: [
        {
          index: true,
          element: <RedirectToNewNpsPage path={navigation.nps.fullPath()} />,
        },
      ],
    },
  ]
}

export default npsRoutes
